import { decodeText } from "../../utility/decodeText.js";
import { applyXOrder, getXOrder } from "./xOrder.js";
/**
 * Gets the Subfile flags.
 * @param flag - First byte of the subheader.
 * @returns The parameters.
 */
export function parseSubFlagParameters(flag) {
    return {
        changed: (flag & 1) !== 0,
        noPeakTable: (flag & 8) !== 0,
        modifiedArithmetic: (flag & 128) !== 0,
    };
}
/**
 * Parses the subheader (header of the subfile).
 * @param buffer - SPC buffer.
 * @param textEncoding - fallback encoding of `subresv` when it is not UTF-8.
 * @returns subheader object.
 */
export function parseSubHeader(buffer, textEncoding = 'windows-1252') {
    const flags = buffer.readUint8();
    return {
        parameters: parseSubFlagParameters(flags),
        exponentY: buffer.readInt8(),
        indexNumber: buffer.readUint16(),
        startingZ: buffer.readFloat32(),
        endingZ: buffer.readFloat32(),
        noiseValue: buffer.readFloat32(),
        numberPoints: buffer.readUint32(),
        numberCoAddedScans: buffer.readUint32(),
        wAxisValue: buffer.readFloat32(),
        reserved: decodeText(buffer.readBytes(4), { encoding: textEncoding }),
        flags,
    };
}
/**
 * Set the X and Y axis (object with labels, values etc.). The order of X is
 * computed once per X array, so the spectra of a common-X file share it, and
 * `fileHeader.xDirection` records it.
 * @param x - X values array, possibly shared by several spectra (not modified).
 * @param y - Y values array, owned by the spectrum (it may be reversed in place).
 * @param fileHeader - main file header.
 * @param shouldSortX - whether to sort the spectrum by increasing X.
 * @param isXOwned - X was read for this spectrum only, so it is taken over
 * instead of copied.
 * @returns object with x and y as axis.
 */
export function setXYAxis(x, y, fileHeader, shouldSortX = true, isXOwned = false) {
    const { x: xAxis, y: yAxis } = fileHeader.axes;
    const xOrder = getXOrder(x);
    if (fileHeader.xDirection === undefined) {
        fileHeader.xDirection = xOrder.direction;
    }
    else if (fileHeader.xDirection !== xOrder.direction) {
        fileHeader.xDirection = 'unordered';
    }
    const { x: oX, y: oY } = applyXOrder(x, y, xOrder, {
        shouldSortX,
        isXOwned,
    });
    const variables = {
        x: {
            symbol: 'x',
            label: xAxis.label,
            units: xAxis.units,
            data: oX,
            isDependent: false,
        },
        y: {
            symbol: 'y',
            label: yAxis.label,
            units: yAxis.units,
            data: oY,
            isDependent: true,
        },
    };
    return variables;
}
//# sourceMappingURL=shared.js.map